import { useEffect, useState, useContext } from "react";
import { AuthContext } from "../context/AuthContext";

const avatars = [
  "/avatars/avatar1.png",
  "/avatars/avatar2.png",
  "/avatars/avatar3.png",
  "/avatars/avatar4.png",
  "/avatars/avatar5.png",
  "/avatars/avatar6.png",
  "/avatars/avatar7.png",
  "/avatars/avatar8.png",
  "/avatars/avatar9.png",
  "/avatars/avatar.png"
];

export default function Perfil() {

  const { token } = useContext(AuthContext);

  const [perfil, setPerfil] = useState(null);

  const [password, setPassword] = useState({
    password_actual: "",
    password_nuevo: ""
  });

  const [editando, setEditando] = useState(false);

  const [notificacion, setNotificacion] = useState({
    mostrar: false,
    mensaje: "",
    tipo: "success"
  });

  const mostrarToast = (mensaje, tipo = "success") => {

    setNotificacion({
      mostrar: true,
      mensaje,
      tipo
    });

    setTimeout(() => {
      setNotificacion({
        mostrar: false,
        mensaje: "",
        tipo: "success"
      });
    }, 3000);

  };

  useEffect(() => {
    cargarPerfil();
  }, []);

  const cargarPerfil = async () => {

    const res = await fetch("/api/usuarios/perfil", {
      credentials: "include",
      headers: { Authorization: `Bearer ${token}` }
    });

    const data = await res.json();
    setPerfil(data);

  };

  const guardarPerfil = async () => {

    try {

      const res = await fetch("/api/usuarios/perfil", {
        method: "PUT",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(perfil)
      });

      const data = await res.json();

      if (!res.ok) {
        mostrarToast(data.message || "Error al actualizar", "error");
        return;
      }

      setEditando(false);
      mostrarToast("Perfil actualizado correctamente");

    } catch {

      mostrarToast("Error al actualizar el perfil", "error");

    }

  };

  const cambiarPassword = async () => {

    if (!password.password_actual || !password.password_nuevo) {
      mostrarToast("Debes llenar ambos campos", "error");
      return;
    }

    if (password.password_nuevo.length < 6) {
      mostrarToast("La nueva contraseña debe tener al menos 6 caracteres", "error");
      return;
    }

    try {

      const res = await fetch("/api/usuarios/password", {
        method: "PUT",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({
          password_actual: password.password_actual,
          password_nuevo: password.password_nuevo
        })
      });

      const data = await res.json();

      if (!res.ok) {
        mostrarToast(data.message || "Error al cambiar contraseña", "error");
        return;
      }

      mostrarToast(data.message);

      setPassword({
        password_actual: "",
        password_nuevo: ""
      });

    } catch {

      mostrarToast("Error al cambiar contraseña", "error");

    }

  };

  if (!perfil) return <div className="p-10">Cargando perfil...</div>;

  return (

    <div className="p-10 bg-gray-100">

      {/* TOAST */}
      {notificacion.mostrar && (
        <div className="fixed top-6 right-6 z-50">
          <div
            className={`px-6 py-3 rounded-lg shadow-lg text-white font-medium
            ${notificacion.tipo === "success"
              ? "bg-green-500"
              : "bg-red-500"}`}
          >
            {notificacion.mensaje}
          </div>
        </div>
      )}

      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-6">

        {/* PERFIL */}
        <div className="bg-white rounded-2xl shadow-lg p-6 text-center">

          <img
            src={perfil.icono || "/avatars/avatar1.png"}
            className="w-32 h-32 rounded-full mx-auto shadow-md border-4 border-blue-500"
            alt="avatar"
          />

          <h2 className="text-xl font-bold mt-4">{perfil.nombre}</h2>
          <p className="text-gray-500">{perfil.email}</p>

          <div className="mt-4 flex justify-center gap-2">

            <span className={`text-xs px-3 py-1 rounded-full
            ${perfil.estatus ? "bg-green-100 text-green-700" : "bg-red-100 text-red-700"}`}>
              {perfil.estatus ? "Activo" : "Inactivo"}
            </span>

            <span className="text-xs bg-blue-100 text-blue-700 px-3 py-1 rounded-full">
              {perfil.rol}
            </span>

          </div>

          <button
            onClick={() => setEditando(!editando)}
            className="mt-6 bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700"
          >
            {editando ? "Cancelar" : "Editar perfil"}
          </button>

        </div>

        {/* INFORMACION */}
        <div className="md:col-span-2 bg-white rounded-2xl shadow-lg p-6">

          <h3 className="text-lg font-bold mb-4">
            Información del usuario
          </h3>

          <div className="space-y-4">

            <input
              disabled={!editando}
              value={perfil.nombre}
              onChange={(e) =>
                setPerfil({ ...perfil, nombre: e.target.value })
              }
              className="w-full border rounded-lg p-2"
            />

            <input
              disabled={!editando}
              value={perfil.email}
              onChange={(e) =>
                setPerfil({ ...perfil, email: e.target.value })
              }
              className="w-full border rounded-lg p-2"
            />

          </div>

          {editando && (

            <>
              <h4 className="font-semibold mt-6 mb-2">
                Seleccionar Avatar
              </h4>

              <div className="grid grid-cols-6 gap-3">

                {avatars.map((a) => (

                  <img
                    key={a}
                    src={a}
                    alt="avatar"
                    onClick={() =>
                      setPerfil({ ...perfil, icono: a })
                    }
                    className={`w-16 h-16 rounded-full cursor-pointer border-2
                    ${perfil.icono === a
                        ? "border-blue-500 scale-110"
                        : "border-gray-200 hover:scale-105"
                      }`}
                  />

                ))}

              </div>

              <button
                onClick={guardarPerfil}
                className="mt-6 bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700"
              >
                Guardar cambios
              </button>

            </>

          )}

        </div>

        {/* SEGURIDAD */}
        <div className="bg-white rounded-2xl shadow-lg p-6">

          <h3 className="text-lg font-bold mb-4">
            Seguridad
          </h3>

          <input
            type="password"
            placeholder="Contraseña actual"
            value={password.password_actual}
            onChange={(e) =>
              setPassword({
                ...password,
                password_actual: e.target.value
              })
            }
            className="w-full border p-2 rounded-lg mb-3"
          />

          <input
            type="password"
            placeholder="Nueva contraseña"
            value={password.password_nuevo}
            onChange={(e) =>
              setPassword({
                ...password,
                password_nuevo: e.target.value
              })
            }
            className="w-full border p-2 rounded-lg mb-4"
          />

          <button
            onClick={cambiarPassword}
            className="w-full bg-red-500 text-white py-2 rounded-lg hover:bg-red-600"
          >
            Cambiar contraseña
          </button>

        </div>

      </div>

    </div>

  );

}